if (document.getElementById("gate-loading") !== null) {
  const bar = new ProgressBar.Circle(gate_loading_text, {
    color: "white",
    trailColor: "black",
    easing: "easeInOut",
    strokeWidth: 0.5,
    //進捗ゲージの太さ
    duration: 2500,
    //時間指定(1000＝1秒)
    trailWidth: 0,
    //線の太さ
    text: {
      style: {
        position: "fixed",
        left: "50%",
        top: "50%",
        padding: "0",
        margin: "0",
        transform: "translate(-50%,-50%)",
        "font-size": "60px",
        "font-family": '"Montserrat"',
        "font-weight": "500",
        color: "#fff",
      },
      autoStyleContainer: false,
    },
    step: function (state, bar) {
      bar.setText(Math.round(bar.value() * 100) + "<span>%</span>");
    },
  });

  bar.animate(1.0, function () {
    $("#gate-loading").delay(500).fadeOut(800);
  });
}

// ハンバーガーボタン
if (document.getElementById("overseas-hamburger") !== null) {
  document.getElementById("overseas-hamburger").addEventListener("click", function () {
    document.getElementById("bar-top").classList.toggle("cross-top");
    document.getElementById("bar-middle").classList.toggle("cross-middle");
    document.getElementById("bar-bottom").classList.toggle("cross-bottom");
    document.getElementById("slide").classList.toggle("open");
  });
}

const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

// ここからリサイズの対応
let vw = window.innerWidth;
window.addEventListener("resize", () => {
  if (vw === window.innerWidth) {
    // 画面の横幅にサイズ変動がないので処理を終える
    return;
  }

  // 画面の横幅のサイズ変動があった時のみ高さを再計算する
  vw = window.innerWidth;
  setFillHeight();
});

// 実行
setFillHeight();
window.addEventListener("resize", setFillHeight);

if (document.getElementById("overseasFv") !== null) {
  setTimeout(() => {
    document.getElementById("overseasFv").classList.add("show");
    setTimeout(() => {
      document.getElementById("overseasTitle").classList.add("show");
    }, 800);
  }, 3800);
}

if (document.getElementById("gate") !== null) {
  document.getElementById("gateCoverLink").addEventListener("click", function () {
    document.getElementById("gateModal").classList.add("open");
  });

  document.getElementById("gateModalMask").addEventListener("click", function () {
    document.getElementById("gateModal").classList.remove("open");
  });

  document.getElementById("gateModalClose").addEventListener("click", function () {
    document.getElementById("gateModal").classList.remove("open");
  });
}
